SaveAsBatchModalController.$inject = [
    '$scope',
    '$modalInstance',
    'batch',
    'achBatchService',
    '$state',
    'securityService',
];

export default function SaveAsBatchModalController(
    $scope,
    $modalInstance,
    batch,
    achBatchService,
    $state,
    securityService
) {
    $scope.batch = batch;
    $scope.copyBatch = angular.copy($scope.batch);
    $scope.save = save;
    $scope.cancel = cancel;
    $scope.templateNameIsValid = false;
    $scope.validateTemplateName = validateTemplateName;

    function validateTemplateName() {
        achBatchService.validateTemplateName($scope.copyBatch.name).then(resp => {
            $scope.templateNameIsValid = resp.isValid;
        });
    }

    async function save() {
        if ($scope.copyBatch.resetAmounts) {
            angular.forEach($scope.copyBatch.recipients, recipient => {
                recipient.amount = 0;
            });
        }
        $scope.copyBatch.id = 0;
        let result;
        await securityService.verifyUser('Create ACH Batch', $scope.copyBatch, async () => {
            result = await achBatchService.create($scope.copyBatch);
            return result;
        });
        $modalInstance.close(result);
        if (result.errorMessage) return;
        $state.go('payables.ach.batch-list');
    }

    function cancel() {
        $modalInstance.dismiss();
    }

    (() => {
        // Init
        validateTemplateName();
    })();
}
